<div class="grid" edsPadding edsPaddingBottom="xl">
  <div class="container">
    <div class="highlight-block highlight-block--form">
      <p>
        {{ brLabels["form-pre-name"] }}
        <input
          type="text"
          alt=""
          [placeholder]="brLabels['form-name-placeholder']"
          class="highlight-block__formfield"
          [value]="name"
          (keyup)="setName($event.target.value)"
        />
        {{ brLabels["form-post-name"] }}
        <select
          (change)="setAge($event.target.value)"
          class="highlight-block__select"
        >
          <option value="0" [attr.selected]="age === 0 ? true : null">
            0 {{ brLabels["years"] }}
          </option>
          <option
            *ngFor="let a of ages; let i = index"
            [value]="i + 1"
            [attr.selected]="i + 1 === age ? true : null"
          >
            {{ i + 1 + " " + (i > 0 ? brLabels["years"] : brLabels["year"]) }}
          </option>
          <option value="19" [attr.selected]="age === 19 ? true : null">
            19+ {{ brLabels["years"] }}
          </option>
        </select>
        {{ brLabels["form-post-age"] }}
      </p>
      <button
        edsButton="primary"
        (click)="getStarted()"
        edsPadding
        edsPaddingTop="md"
        edsPaddingBottom="md"
        [disabled]="name?.length < 1 ? 'disabled' : null"
      >
        {{ brLabels["form-button"] }}
      </button>
    </div>
  </div>
</div>
